import { PromotionV2 } from '@occ/api-client';

const promotionApi = new PromotionV2({ baseUrl: '' });

export const getOfflinePreviewCampaigns = async (
  q?: string,
  fields?: Array<string>,
  page?: number,
  size?: number,
  dateFrom?: number,
  dateTo?: number
) => {
  const response = await promotionApi.getOfflineCampaignsPreviewV2({ q, fields, page, size, dateFrom, dateTo });
  return response.data;
};

export const getOfflineCampaigns = async (q: string, type?: string, page?: number, size?: number) => {
  const response = await promotionApi.getOfflineCampaignsV2({ q, type, page, size });
  return response.data;
};

export const getOnlineCampaigns = async (q: string, type?: string, page?: number, size?: number) => {
  const response = await promotionApi.getOnlineCampaignsV2({ q, type, page, size });
  return response.data;
};
